import banner_include from "../../Assets/Images/Projects/banner-include.png";
import header_include from "../../Assets/Images/Projects/header-include.jpg";
import meeting from "../../Assets/Images/Projects/meeting-include.jpg";
import leaflet_include from "../../Assets/Images/Projects/leaflet-include.jpg";
import sdg from "../../Assets/Images/Projects/sdg.jpg";
import { photoObjectFormatter } from "./TVET";

const INCLUDETemplate = () => {
  const projectInfo = {
    location: "Sirajganj, Gaibandha, Chapainawabganj, and Charghat",
    title: "Innovations for Climate-smart Urban Development (INCLUDE) Project",
    client: "Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ)",
    funded_by:
      "German Federal Ministry for Economic Cooperation and Development (BMZ)",
    middle_description_up: `INCLUDE project is part of the Climate Change & Sustainable Urban Development Cluster at GIZ Bangladesh. 
    It focuses on fostering climate-smart urban development in Sirajganj, Gaibandha, Chapainawabganj, and Charghat through inclusive,
     locally led innovation. The project engages marginalized groups—women, youth, the elderly, and persons with disabilities—through
      an Innovation Lab and a nationwide Call for Ideas competition to co-create digital solutions that strengthen climate resilience. 
      In its initial phase, INCLUDE is centered on identifying local challenges, generating ideas, and building partnerships with civil society, 
      research institutions, and the private sector. With political support from the Ministry of Local Government,
       Rural Development and Cooperatives (MoLGRD&C) and implementation by the Local Government Engineering Department (LGED),
        the project aims to address the growing climate vulnerabilities of rapidly urbanizing areas and contribute to national
         policy through peer learning and capacity development.`,
    rendered_service: "Development Plan, Climate Change & DRR",
    right_description_up: `The project emphasized IEC materials and knowledge sharing through reports, insights, and interactive sessions to foster cross-learning among municipalities. Stakeholder engagement was integral, ensuring inclusive dialogue and continuous feedback throughout the process.`,
    left_description: `Context analysis was supported
by literature reviews, surveys,
and stakeholder mapping,
visualized through infographics
and dashboards. Digital
platforms enabled streamlined
data collection via workshops,
FGDs, and KIIs, informing a
deeper understanding of urban
challenges.`,
    right_description_down: `The team facilitated ideation
for climate-resilient solutions,
launching an inclusive Call for
Ideas with a focus on
marginalized groups. Selected
proposals were refined and
implemented with live
monitoring and coordination
alongside the INCLUDE team
and government partners.`,

    meeting_image: photoObjectFormatter(
      meeting,
      `Problem Definition and First Ideation Workshop held in Sirajganj Pourashava to identify local
challenges and explore early solution ideas.`,
      ""
    ),
    leaflet_image: photoObjectFormatter(
      leaflet_include,
      `Infographics for Gaibandha Pourashava used in the Problem Definition and First Ideation
Workshop to help explain key issues and spark ideas.`,
      ""
    ),
    sdg_image: photoObjectFormatter(sdg, ""),
    banner_include_image: photoObjectFormatter(
      banner_include,
      `This IEC material shows the INCLUDE Project’s commitment to inclusion, making sure everyone in the community is
represented and valued.`,
      ""
    ),
    header: photoObjectFormatter(header_include, ""),
    professional_staff: [
      { name: `Md. Anisur Rahman`, designation: `Lead consultant` },
      {
        name: `Tamanna Salam`,
        designation: `Event Management and Stakeholder Engagement Specialist`,
      },
      { name: `Tamzidul Islam`, designation: `Team Lead/ GIS Expert` },
      {
        name: `Taufique Mohiuddin`,
        designation: `Participatory Planning and Citizen Engagement Specialist`,
      },
      { name: `Rayhanul Zannat`, designation: `Tech-Affine Urban Specialist` },
      {
        name: `Farhana Muna`,
        designation: `Urban Development Specialist`,
      },
      {
        name: `Md. Sahabuddin`,
        designation: `Monitoring & Evaluation (M&E) Specialist`,
      },
      {
        name: `Sabiha Mahbuba Siza`,
        designation: `Technical Backstopper`,
      },
      {
        name: `Razeeb Robert Rozario`,
        designation: `Administrative Backstopper`,
      },
    ],
  };

  const {
    title,
    location,
    client,
    funded_by,
    rendered_service,
    middle_description_up,
    right_description_up,
    middle_description_down,
    left_description,
    right_description_down,
    meeting_image,
    leaflet_image,
    professional_staff,
    sdg_image,
    banner_include_image,
    header,
  } = projectInfo;

  const gridItems = [
    { title: "Location and Area", content: location },
    { title: "Funded By", content: funded_by },
    { title: "Client", content: client },
    { title: "Rendered Service", content: rendered_service },
  ];

  const GridItem = ({ items }) => {
    return (
      <div className="relative">
        <divider className="absolute h-[100%] left-1/2 translate-x-[45%]  border-2 border-lime-500"></divider>
        <div className=" hidden lg:block    absolute left-[40%] translate-x-8 -translate-y-2.5  border-t-4 border-lime-500 mb-1 mt-2 w-[5%]"></div>
        <div className="   hidden lg:block  absolute right-[40%] transform  translate-y-36  border-t-4 border-lime-500 my-1 w-[5%]"></div>

        <div className="grid grid-cols-2 gap-5">
          {items.map((item, index) => (
            <div
              key={index}
              className="p-2 odd:ml-auto odd:text-end   border-lime-500 "
            >
              <b>{item.title}</b> <br />
              <small>{item.content}</small>
            </div>
          ))}
        </div>
      </div>
    );
  };
  return (
    <div className=" text-sm md:text-[15px]">
      <div className="h-[30%] sm:h-[40%]">
        <img
          src={header?.photo}
          alt="INCLUDE header image"
          className="w-full h-full object-contain"
        />
      </div>
      <div className="px-[8%]">
        <div className="flex flex-col justify-center items-center">
          <p className="font-bold  text-3xl my-5 text-gray-700  text-center  md:w-1/2">
            {title}
          </p>

          <p className="tracking-wide leading-loose  text-justify ">
            {middle_description_up}
          </p>
        </div>

        <div className="mt-8">
          <GridItem items={gridItems} />
        </div>

        <div className="    gap-5 my-10  sm:my-16">
          <div className="h-[20%]  sm:h-[28%]  xl:w-[60%] mx-auto">
            <img
              src={sdg_image?.photo}
              alt="SDG"
              className="w-full h-full object-contain"
            />
          </div>
          <p className="   tracking-wide text-justify">
            {right_description_up}
          </p>
        </div>

        <div className="relative w-full">
          <div className="h-[35%]  sm:h-[48%]  xl:w-[60%] mx-auto">
            <img
              src={banner_include_image?.photo}
              alt="include banner"
              className="w-full h-full object-cover"
            />
            <p className="w-full italic text-xs text-center">
              {banner_include_image.caption}
            </p>
          </div>
        </div>

        <p className="mt-[15%]  text-justify md:text-center    ">
          {middle_description_down}
        </p>

        <div className=" mb-2 ">
          <div className="flex flex-col md:flex-row  items-center xl:gap-5  lg:gap-8 md:gap-5  md:my-16 mb-6">
            <p className="basis-[50%] xl:basis-full 2xl:text-right max-w-3xl text-justify leading-normal w-[1/4]">
              {left_description}
            </p>
            <div className="w-full  lg:[80vh]">
              <img
                src={leaflet_image?.photo}
                alt="leaflet_image"
                className="h-[80%] object-contain  mx-auto"
              />
              <p className="w-full italic text-xs text-center">
                {leaflet_image.caption}
              </p>
            </div>
          </div>

          <div className="flex flex-col-reverse md:flex-row-reverse  items-center xl:gap-5  lg:gap-8 md:gap-5  md:my-16 mb-6">
            <p className="basis-[50%] xl:basis-full 2xl:text-right max-w-3xl text-justify leading-normal w-[1/4]">
              {right_description_down}
            </p>
            <div className="w-full ">
              <img
                src={meeting_image?.photo}
                alt="meeting_image"
                className="h-full object-contain  mx-auto"
              />
              <p className="w-full italic text-xs text-center">
                {meeting_image.caption}
              </p>
            </div>
          </div>

          <div className="my-10">
            <strong className="text-lg ">
              Name of senior professional staff
            </strong>
            <div className="flex flex-col gap-2 mt-4">
              {professional_staff?.map(({ name, designation }) => (
                <p>
                  <strong className="mr-1">{name},</strong>
                  {designation}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default INCLUDETemplate;
